import request from "@/http/";
import { URL_LIST } from "@/config/";

export async function login(data) {
  try {
    const params = {
      url: URL_LIST.LOGIN,
      data: data,
    };
    const result = request.post(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function loginOut(data) {
  try {
    const params = {
      url: URL_LIST.LOGIN_OUT,
      data: data,
    };
    const result = request.post(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getCustomsBySearch(data) {
  try {
    const params = {
      url: URL_LIST.GET_CUSTOMS_BY_SEARCH,
      data: data,
    };
    const result = request.formDataPost(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getWxSingAPI(data) {
  try {
    const params = {
      url: URL_LIST.WX_SIGN,
      data: data,
    };
    const result = request.formDataPost(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getInvoiceInfoAPI(data) {
  try {
    const params = {
      url: URL_LIST.UPLOAD_INVOICE,
      data: data,
    };
    const result = request.post(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function uploadImgsAPI(data) {
  try {
    const params = {
      url: URL_LIST.UPLOAD_IMGS,
      data: data,
    };
    const result = request.post(params);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js